<template>
    <div :class="[`backdrop ${isShowInvitesBlock ? 'show-backdrop' : ''}`]" @click.stop="onCloseBlock">
        <div :class="`dropdown-categories-block ${isShowInvitesBlock ? 'show' : ''}`" @click.stop="">
            <div class="dropdown-header-block">
                <p class="dropdown-header-title">{{ $t('invitesPage.shareBlockTitle') }}</p>
            </div>
            <div class="share-variants-container">
                <div>
                    <a :href="`https://t.me/share/url?url=${getInvitedLink.referer_link}&text=${getInvitedLink.message}`"
                        class="share-element-item" @click="isInviteFriends">
                        <send-icon class="share-element-item-icon" />
                    </a>
                    <p class="reply-text">{{ $t('invitesPage.shareToTelegram') }}</p>
                </div>
                <div>
                    <button @click="onCopieText" class="share-element-item">
                        <link-icon class="share-element-item-icon" />
                    </button>
                    <p class="reply-text">{{ $t('invitesPage.copyLink') }}</p>
                </div>
                <!-- <div>
                    <a href="" class="share-element-item">
                        <three-dots-icon class="share-element-item-icon" />
                    </a>
                    <p class="reply-text">Більше</p>
                </div> -->
            </div>
            <div :class="`tooltip ${isCopiedText ? 'show' : ''}`">
                {{ $t('invitesPage.successCopied') }}
            </div>
        </div>
    </div>
</template>

<script>

import {
    LinkIcon,
    SendIcon
} from 'vue-feather-icons';
// import ThreeDotsIcon from '../../resources/js/icons/ThreeDotsIcon.vue';

export default {
    name: "Share-to-friends-block",
    components: {
        LinkIcon,
        SendIcon,
        // ThreeDotsIcon
    },
    props: {
        isShowInvitesBlock: {
            type: Boolean,
            require: true
        },
    },
    data() {
        return {
            isCopiedText: false
        }
    },
    async mounted() {

    },

    methods: {
       async onCopieText() {
            console.log(this.getInvitedLink)
            await navigator.clipboard.writeText(this.getInvitedLink.referer_link);
            this.isCopiedText = true;
            setTimeout(() => {
                this.isCopiedText = false;
            }, 2000);
        },
        onCloseBlock() {
            this.$emit('on-backdrop-click')
            setTimeout(() => {
                this.isCopiedText = false
            }, 500)
        },
        isInviteFriends() {
            this.$emit('on-invite-friend')
        }
    },
    computed: {
        getInvitedLink() {
            return this.$store.getters.getInvitedLink
        }
    },
    watch: {

    }
}
</script>

<style scoped>
.dropdown-categories-block {
    position: fixed;
    width: 100%;
    z-index: 1000000000;
    height: 22vh;
    left: 0px;
    bottom: 0px;
    background: #e8e8e8;
    transform: translateY(100%);
    transition: all .5s ease;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.07);
}

.dropdown-categories-block.show {
    transform: translateY(0);
}

.dropdown-header-block {
    padding: 15px 10px;
}

.dropdown-header-title {
    font-size: 18px;
    line-height: 25px;
    font-weight: 700;
    color: #1b1b1b;
    font-family: "Source Sans Pro", sans-serif;
    letter-spacing: -0.6px;
    margin-bottom: 0px;
    text-align: center;
}


.create-bayment-close-button {
    cursor: pointer;
    background: transparent;
    border: none;
    margin-left: auto;
}

.create-payment-close-icon {
    width: 26px;
    height: 26px;
    color: #d84558;
}

.share-variants-container {
    display: flex;
    padding: 5px 10px;
    gap: 20px;
}

.share-element-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    transition: all 120ms ease;
    border-radius: 50%;
    border: none;
    background-image: var(--main-bg-color);
    position: relative;
    z-index: 10;
    margin: 0 auto;
    cursor: pointer;
    overflow: visible !important;
}

.share-element-item-icon {
    color: #fff;
}

.reply-text {
    text-align: center;
    max-width: 65px;
    line-height: 15px;
    margin-top: 5px;
}

.tooltip {
    position: fixed;
    background-color: #545454;
    color: #fff;
    border: 1px solid #ccc;
    padding: 0 10px;
    border-radius: 5px;
    bottom: 10px;
    left: 50%;
    transition: all .5s ease;
    transform: translate(-50%, 200%);
}

.tooltip.show {
    transform: translate(-50%, 0%);
}

@media (max-height: 650px) {
    .dropdown-header-block {
        padding: 8px 10px;
    }
    .share-element-item {
        width: 30px;
        height: 30px;
    }
    .share-element-item-icon {
        width: 15px;
        height: 15px;
    }
    .reply-text {
        font-size: 10px;
    }
}

@media (max-height: 500px) {
    .dropdown-categories-block {
        height: 25vh;
    }
}

</style>